import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  getPublicInsuranceDetails,
  addPublicRemark,
} from "./store";

import VehicleCard from "./components/VehicleCard";
import DocumentsSection from "./components/DocumentsSection";
import TimelineSection from "./components/TimelineSection";
import RemarksSection from "./components/RemarksSection";

import "./insuranceDetails.css";
import AccidentSection from "./components/AccidentSection";

const InsuranceDetails = () => {
  const { id } = useParams();

  const [insurance, setInsurance] = useState(null);
  const [remarks, setRemarks] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadInsurance = async () => {
    try {
      setLoading(true);

      const res = await getPublicInsuranceDetails(id);

      setInsurance(res.data.claim);
      setRemarks(res.data.remarks || []);
    } catch (err) {
      console.log(err);
      alert("Unable to load insurance details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInsurance();
  }, [id]);

  if (loading) {
    return (
      <div className="loading-container">
        Loading Insurance Details...
      </div>
    );
  }

  if (!insurance) {
    return (
      <div className="loading-container">
        Insurance Claim not found.
      </div>
    );
  }

  return (
    <div className="insurance-page">

      <div className="insurance-header">
        <div>
          <p className="header-eyebrow">Insurance Claim</p>
          <h1>{insurance.ticket_id?.heading || "Claim Overview"}</h1>
          <p className="header-claim-id">
            Claim ref <b>#{insurance._id?.slice(-8).toUpperCase()}</b>
            {insurance.ticket_id?.vehicle_number && (
              <> · Vehicle <b>{insurance.ticket_id.vehicle_number}</b></>
            )}
          </p>
        </div>

        <span className={`status ${insurance.status?.toLowerCase()}`}>
          {insurance.status}
        </span>
      </div>

      <div className="insurance-layout">

        <div className="insurance-left">

          <VehicleCard insurance={insurance} />
          <AccidentSection
    accident={insurance.ticket_id?.accident}
  />

          <DocumentsSection documents={insurance.documents} />

          <TimelineSection insurance={insurance} />

        </div>

        <div className="insurance-right">

          <RemarksSection
            remarks={remarks}
            claimId={insurance._id}
            addPublicRemark={addPublicRemark}
            reloadData={loadInsurance}
          />

        </div>

      </div>

    </div>
  );
};

export default InsuranceDetails;